import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { fetchData } from "../fetchData";
import { getLatestUserCookie } from '../../components/Login/user_session';
function useProfile(apiPath) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    userProfile = _useState2[0],
    setUserProfile = _useState2[1];
  useEffect(function () {
    getLatestUserCookie().then(function (userCookie) {
      if (userCookie.login_status && !userCookie.error) {
        fetchData({
          path: "".concat(apiPath, "/graphql/user"),
          options: {
            method: 'POST',
            body: JSON.stringify({
              query: "{ userProfile { firstName, lastName, email, country } }"
            })
          },
          authToken: userCookie.access_token
        }).then(function (data) {
          if (data.data.userProfile) {
            var _data$data$userProfil = data.data.userProfile,
              firstName = _data$data$userProfil.firstName,
              lastName = _data$data$userProfil.lastName,
              email = _data$data$userProfil.email;
            setUserProfile({
              firstName: firstName,
              lastName: lastName,
              email: email
            });
          }
        });
      }
    });
  }, [apiPath]);
  return userProfile;
}
export default useProfile;